import dayjs from 'dayjs';

/**
 * 时间格式化
 * @param time 时间
 * @param format 格式
 * @returns {string}
 */
export function formatDateTime(time, format = 'YYYY-MM-DD HH:mm:ss') {
  return time ? dayjs(time).format(format) : '暂无时间';
}

/**
 * 将数字格式化成每 3 位添加一个逗号
 * @param content 待格式化的金额/数字
 * @returns {string} 返回格式化后的数字
 */
export function handleNumber(content) {
  return content.toLocaleString('en-US');
}

/**
 * 手机号码隐藏中间4位
 * @param phone
 */
export const hidePhoneNumber = phone => {
  const reg = /^(\d{3})\d{4}(\d{4})$/;
  return phone ? phone.replace(reg, '$1****$2') : '';
};
/**
 * 处理富文本里的图片宽度自适应
 * 1.去掉img标签里的style、width、height属性
 * 2.img标签添加style属性：max-width:100%;height:auto
 * 3.修改所有style里的width属性为max-width:100%
 * 4.去掉<br/>标签
 * @param html
 * @returns {void|string|*}
 */
export const formatRichText = html => {
  // eslint-disable-next-line no-unused-vars
  let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
    match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
    match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
    match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
    return match;
  });
  // eslint-disable-next-line no-unused-vars
  newContent = newContent.replace(/style="[^"]+"/gi, function (match, capture) {
    match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
    return match;
  });
  newContent = newContent.replace(/<br[^>]*\/>/gi, '');
  newContent = newContent.replace(
    /\<img/gi,
    '<img style="max-width:100%;height:auto;display:inline-block;margin:10rpx auto;"',
  );
  return newContent;
};
